import React, { Component } from 'react';
import { Card, Col, message, Row } from 'antd';
import { browserHistory } from 'react-router';
import Process from '@comm/workflow/Process';
import Opration from '@comm/workflow/WorkflowOp';
import ProcessHistory from '@comm/workflow/ProcessHistory';
import Comment from '@comm/comment/Index';

import {
  queryCallbackWage,
  queryNextWage,
  queryReturnWage,
  querySaveWage,
  queryWageDetailList,
} from '@api/hr/wage';
import FormOpen from './FormOpen';

class Page extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dataInfo: {},
      dataList: [],
      total: 0,
      pageNo: 1,
      isLoading: false,
    };
  }

  componentWillMount() {}

  componentDidMount() {
    const { data } = this.props;
    this.setState({ dataInfo: data });
    this.wageDetailList();
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      dataInfo: nextProps.data,
    });
  }

  /**
   * 提交报销
   */
  handSubmit = (item, type) => {
    if (type === 'save') {
      this.saveWage(item);
    }
  };

  /**
   * 保存
   */
  saveWage = item => {
    querySaveWage(item).then(res => {
      if (res.statusCode === 200) {
        message.success('保存成功');
        browserHistory.go(-1);
      } else {
        message.error(res.message);
      }
    });
  };

  /**
   * 处理流程
   */
  doTask = (pass, refuse) => {
    const { dataInfo } = this.state;
    const instance = dataInfo.instance || {};
    const item = {
      instanceUuid: instance.uuid,
    };
    switch (pass) {
      case 'callback':
        this.callbackWage(item);
        break;
      case 'next':
        this.nextWage(item);
        break;
      case 'return':
        this.returnWage(item, refuse);
        break;
      default:
        break;
    }
  };

  // 收回
  callbackWage = params => {
    queryCallbackWage(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        browserHistory.go(-1);
      } else {
        message.error(res.message);
      }
    });
  };

  // 通过
  nextWage = params => {
    this.setState({ isLoading: true });
    queryNextWage(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        browserHistory.go(-1);
        this.setState({ isLoading: false });
      } else {
        message.error(res.message);
        this.setState({ isLoading: false });
      }
    });
  };

  // 打回
  returnWage = (params, refuse) => {
    queryReturnWage({
      ...params,
      ...refuse,
    }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        browserHistory.go(-1);
      } else {
        message.error(res.message);
      }
    });
  };

  handleCancel = () => {};

  /**
   * 查看流程
   */
  watchTask = () => {};

  /** ---------------------------------工资审核页新增 工资列表详情---------------------------------*/
  wageDetailList = pageNo => {
    const { data } = this.props;
    const params = {};
    const no = this.state.pageNo;
    const current = pageNo || no;
    params.companyUuid = data.companyUuid;
    params.year = data.year;
    params.month = data.month;
    params.limit = 15;
    params.start = current;
    queryWageDetailList({
      ...params,
    }).then(res => {
      this.setState({
        dataList: res.data,
        total: res.totalSize,
      });
    });
  };
  /**--------------------------------------------------------------------------------------------*/

  render() {
    const { dataInfo, dataList, total, isLoading } = this.state;
    const instance = dataInfo.instance || {};
    const histories = dataInfo.histories || [];
    const pagination = {
      showSizeChanger: false,
      pageSize: 15,
      total,
      current: this.state.pageNo,
      onChange: current => {
        this.wageDetailList(current);
      },
      showTotal: showTotal => {
        return `共 ${showTotal} 条`;
      },
    };
    return (
      <div>
        <Opration
          data={dataInfo}
          doTask={this.doTask}
          watchTask={this.watchTask}
          isLoading={isLoading}
        />
        <FormOpen
          data={dataInfo}
          dataList={dataList}
          pagination={pagination}
          handSubmit={this.handSubmit}
          doTask={this.doTask}
          watchTask={this.watchTask}
        />

        <Card title="流程跟踪">
          <Row justify="center">
            <Col span={24} style={{ marginBottom: '16px', fontSize: '14px' }}>
              <div style={{ marginBottom: '16px', fontSize: '14px' }}>流程路径：</div>
              <Process instance={instance} />
            </Col>
            <Col span={24}>
              <ProcessHistory dataSource={histories} />
            </Col>
          </Row>
        </Card>
        <Comment target={{ type: 'wage', uuid: dataInfo.uuid }} />
      </div>
    );
  }
}

export default Page;



// WEBPACK FOOTER //
// ./src/components/hr/wage/PageOpen.js